import { QuickFilter } from 'services/antt';

export const formatCurrency = (value: number, showSign?: boolean) => {
  const optSign = { style: 'currency', currency: 'BRL' };
  const optNoSign = { minimumFractionDigits: 2 };

  return new Intl.NumberFormat('pt-BR', showSign ? optSign : optNoSign).format(value);
};

export const parseBrazilianNumber = (value?: string | null): number => {
  if (!value) return 0;

  const normalized = value.replace(/\./g, '').replace(',', '.');
  const parsed = Number(normalized);

  return Number.isNaN(parsed) ? 0 : parsed;
};

export const formatPercentage = (value: number) => {
  return new Intl.NumberFormat('pt-BR', { style: 'percent' }).format(value / 100);
};

export const bytesToMB = (bytes: number): string => {
  const MB = bytes / (1024 * 1024);
  return MB.toFixed(2);
};

export const buildQuickFilterUrl = (filter: QuickFilter) => {
  const { date_ref = '', from = '', to = '', columns = [] } = filter;
  const dateRefParam = date_ref ? `&date_ref=${date_ref}` : '';
  const fromParam = from ? `&from=${from}` : '';
  const toParam = to ? `&to=${to}` : '';

  const columnsParams = columns
    .map((column, index) => {
      let columnParam = `&columns[${index}][name]=${column.name}`;
      columnParam +=
        column.filter !== undefined && column.filter !== '' ? `&columns[${index}][filter]=${column.filter}` : '';
      return columnParam;
    })
    .join('');

  return `${dateRefParam}${fromParam}${toParam}${columnsParams}`;
};
